import React from 'react';
import { connect } from 'react-redux';
import {
  ContentWrapper,
  LeftColumnWrapperVersionTwo,
  RightColumnWrapperVersionTwo,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import { askConfirmAction } from 'actions/confirm-action';
import { browserHistory } from 'react-router';
import { getFormValues, isDirty } from 'redux-form';
import { push } from 'react-router-redux';
import NoDataAndLoading from 'components/NoDataAndLoading';
import {
  bankAccountPageRequest,
  addOutletstoBankForm,
  onClickSaveBank,
  showModalConfirmChanges,
  onClickCancelAddBank,
} from 'actions/setting/bankAccount';
import FormBank from './FormBank/FormBank';
import List from './List/List';
import ModalAssignOutlets from './ModalAssignOutlets/ModalAssignOutlets';
import ConfirmSaveAllModal from './FormBank/ConfirmSaveAllModal/ConfirmSaveAllModal';
import ConfirmChangeModal from './FormBank/ConfirmChangesModal/ConfirmChangesModal';
import ActionBar from './ActionBar';

class BankAccount extends React.Component {
  componentDidMount() {
    this.props.dispatch(bankAccountPageRequest());
    browserHistory.listenBefore(location => {
      if (this.props.data.isDirtyForm && !this.props.nextAction) {
        // negate the change location, instead use sagas to handle the change location
        this.props.dispatch(askConfirmAction(push(location.pathname)));
        return false;
      }
    });
  }

  componentWillUnmount() {
    this.props.dispatch(onClickCancelAddBank());
  }

  render() {
    const {
      openRightColumn,
      rightColumnType,
      showModalAssignOutlets,
      showLoadingSpinnerPage,
      bankList,
      bankAccountLists,
    } = this.props;
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <div className="visible-below-1440px">
            <LeftColumnWrapperVersionTwo openRightColumn={openRightColumn}>
              <NoDataAndLoading
                showLoadingSpinner={showLoadingSpinnerPage}
                noDataToDisplay={bankAccountLists.length === 0}
                title="No Data To Display"
                description="Add your bank account and activate mobile payment to join endless promo from our partner."
                linkLabel="Mobile payment acceptance"
                linkUrl="https://www.youtube.com/watch?v=AG7trV3R17Y"
              />
              {bankAccountLists.length !== 0 && <List />}
            </LeftColumnWrapperVersionTwo>
            <RightColumnWrapperVersionTwo openRightColumn={openRightColumn}>
              {rightColumnType === 'form' && (
                <FormBank banks={bankList} onSubmit={this._onFormSubmit} />
              )}
              {rightColumnType === 'edit' && (
                <FormBank banks={bankList} onSubmit={this._onFormSubmit} />
              )}
              {showModalAssignOutlets && (
                <ModalAssignOutlets onSubmit={this._onModalSubmit} />
              )}
            </RightColumnWrapperVersionTwo>
          </div>
          <div className="visible-above-1440px">
            <LeftColumnWrapper openRightColumn={openRightColumn}>
              <NoDataAndLoading
                showLoadingSpinner={showLoadingSpinnerPage}
                noDataToDisplay={bankAccountLists.length === 0}
                title="No Data To Display"
                description="Add your bank account and activate mobile payment to join endless promo from our partner."
                linkLabel="Mobile payment acceptance"
                linkUrl="https://www.youtube.com/watch?v=AG7trV3R17Y"
              />
              {bankAccountLists.length !== 0 && <List />}
            </LeftColumnWrapper>
            <RightColumnWrapper openRightColumn={openRightColumn}>
              {rightColumnType === 'form' && (
                <FormBank banks={bankList} onSubmit={this._onFormSubmit} />
              )}
              {rightColumnType === 'edit' && (
                <FormBank banks={bankList} onSubmit={this._onFormSubmit} />
              )}
              {showModalAssignOutlets && (
                <ModalAssignOutlets onSubmit={this._onModalSubmit} />
              )}
            </RightColumnWrapper>
          </div>
        </ContentWrapper>
        <ConfirmSaveAllModal />
        <ConfirmChangeModal />
      </PageWrapper>
    );
  }

  _onFormSubmit = values => {
    const { rightColumnType } = this.props;
    if (rightColumnType === 'form') {
      this.props.dispatch(onClickSaveBank(values));
    } else if (rightColumnType === 'edit') {
      this.props.dispatch(showModalConfirmChanges());
    }
  };

  _onModalSubmit = (outletsValue, unlinkOutlets) => {
    this.props.dispatch(addOutletstoBankForm(outletsValue, unlinkOutlets));
  };
}

function mapStateToProps(state) {
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  const {
    openRightColumn,
    rightColumnType,
    showModalAssignOutlets,
    bankList,
    bankAccountLists,
  } = state.setting.bankAccount;
  return {
    data: {
      moka: state.moka,
      isDirtyForm: isDirty('bankAccount')(state),
    },
    bankList,
    bankAccountLists,
    openRightColumn,
    rightColumnType,
    showModalAssignOutlets,
    showLoadingSpinnerPage,
    search: getFormValues('search')(state),
    nextAction: state.confirmAction.nextAction,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BankAccount);
